import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdoclicLogsService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  public logs: Array<string> = [];

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  constructor() { }

  add(log: string): void {
    this.logs.push(log);
  }

  push(
    patient_id?: number
  ): Observable<void> {
    const headers = this.getHeaders();

    let map: Map<string, any> = new Map();
    map.set('logs', this.logs);
    patient_id ? map.set('patient_id', patient_id) : null;

    const body = Object.fromEntries(map);

    this.logs = [];

    return this.http.post<any>(`${environment.api.gateway}ordoclic/logs`, body, {
      headers,
    });
  }
}
